// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"380c4828","787":"30291363","972":"caaf4763"}[chunkId] + ".chunk.js";
};